var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiFillCaretLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8399 4.51445L8.42739 13.4941C8.12935 13.7512 8.12935 14.2461 8.42739 14.5059L18.8399 23.4855C19.2282 23.8191 19.7969 23.5184 19.7969 22.9797V5.02031C19.7969 4.48164 19.2282 4.18085 18.8399 4.51445Z",
    fill: "#737373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiFillCaretLeft);
export default __webpack_public_path__ + "static/media/AiFillCaretLeft.ee6e03b7bad1f848be8e16b882b6b519.svg";
export { ForwardRef as ReactComponent };